import React from 'react';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';

import WidgetAjax from '../../widget/WidgetAjax';
import WidgetTree from '../../widget/WidgetTree';
import WidgetTable from '../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from '../../widget/WidgetComponent';

import 'antd/dist/antd.css';

class RolePrivilege extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path, group;

        path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        if( this.props.location!==undefined && this.props.location.state!==undefined )
        {
            group = this.props.location.state.group;
        }

        this.state = {
            path : path,
            tableData : undefined,
            columns : [
                { name: 'name', title: '界面名称', type: 'string', description: '界面名称', properties: { hidden: false }},
                { name: 'title', title: '界面标题', type: 'string', description: '界面标题', properties: { hidden: false }},
                { name: 'fullPath', title: '界面路径', type: 'string', description: '界面路径', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [{ name: '删除', click: "remove"} ]
                    }
                }
            ],
            total:undefined,
            options : {},
            treeData : undefined,
            treeOptions : {
                type : "check",
                cascade : false,
                cascadeUp : true,
            },
            treeDefaultValue : [],
            methodPrivileges : [],
            group : group!==undefined ? group : {},
            messageOptions : {
                title : "信息",
            },
            beforeParentPage:{}
        };
        
        this.onEvent = this.onEvent.bind(this);
       
        this.savePage = this.savePage.bind(this);
        this.onSavePage = this.onSavePage.bind(this);
        this.cancelPage = this.cancelPage.bind(this);
        
        this.nodeOnSelect = this.nodeOnSelect.bind(this);
        this.findTreeNode = this.findTreeNode.bind(this);
        this.buildTreeData = this.buildTreeData.bind(this);
        this.findTableData = this.findTableData.bind(this);
        
        this.buildFullPath = this.buildFullPath.bind(this);
        this.buildTableData = this.buildTableData.bind(this);
        
        this.groupPrivilege=this.groupPrivilege.bind(this);

        this.loadComponent = this.loadComponent.bind(this);
        this.onLoadComponent = this.onLoadComponent.bind(this);
        
        this.loadGroupPrivilege = this.loadGroupPrivilege.bind(this);
        this.onLoadGroupPrivilege = this.onLoadGroupPrivilege.bind(this);   

        this.buildGroupPrivilege = this.buildGroupPrivilege.bind(this);
        this.removeGroupPrivilege = this.removeGroupPrivilege.bind(this);
    }

    componentDidMount()
    {
        this.setState({beforeParentPage:this.props.location.state.group });

        this.loadComponent();
    }


    
    messageRef = ( ref ) => {
        this.messageRef = ref;
    }


    loadComponent()
    {
        const { path } = this.state;

        WidgetAjax.ajax({url:path + 'component/info', params:undefined, callback:this.onLoadComponent});
    }

    onLoadComponent( result, params )
    {
        if( result.status===0 )
        {
            let treeData = this.buildTreeData(result.results, -1);

            this.setState({treeData:treeData});

            this.loadGroupPrivilege();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    loadGroupPrivilege()
    {
        const { group, path } = this.state;

        let params = {
            id : group.id
        }

        WidgetAjax.ajax({url:path + 'role/privilege', params:params, callback:this.onLoadGroupPrivilege});
    }

    onLoadGroupPrivilege( result, params )
    {
        if( result.status===0 )
        {
            this.buildGroupPrivilege(result.result);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    buildGroupPrivilege( data )
    {
        let { treeData, options } = this.state;

        let treeDefaultValue = [], tableData = [], methodPrivileges = [];

        for( let key in data )
        {
            if( data[key].type==="COMPONENT" )
            {
                treeDefaultValue.push(key);

                let item = this.findTableData(key, treeData ); 

                if( item!==undefined && item!==null )
                {
                    tableData.push(item);
                }
            }
            else
            {
                methodPrivileges.push(data[key]);
            }
        }

        options["records"] = tableData.length;

        this.setState({treeDefaultValue:treeDefaultValue, tableData:tableData, total:tableData.length, options:options, methodPrivileges:methodPrivileges});
    }

    /**
     * 查找表格数据
     * @param {*} key 
     * @param {*} treeData 
     * @param {*} parentPath 
     * @returns 
     */
    findTableData( key, treeData, parentPath)
    {
        let data = {};

        for( let item of treeData)
        {
            let fullPath = parentPath;

            if( fullPath!==undefined && fullPath!==null && fullPath!=="" )
            {
                fullPath += "/" + item.label;
            }
            else
            {
                fullPath = item.label;
            }

            if( item.value===key )
            {
                data["name"] = item.value;
                data["title"] = item.label;
                data["type"] = item.type;
                data["access"] = item.access;
                data["path"] = item.path;

                data["fullPath"] = fullPath;

                return data;
            }
            else
            {
                if( item.children!==undefined )
                {
                    data = this.findTableData(key, item.children, fullPath);

                    if( data!==undefined && data!==null && Object.keys(data).length>0 )
                    {
                        return data;
                    }
                    else
                    {
                        data = {};
                    }
                    
                }
            }
        }
    }

    /**
     * 创建树形结构数据
     * @param {*} data 
     * @param {*} parent 
     * @returns 
     */
    buildTreeData( data, parent)
    {
        const { groupPrivilege } = this.state;

        let items = [];

        for( let i=0; i<data.length; i++ )
        {
            let node = {};
            
            node.label = data[i].title;
            node.parent = parent;
            node.name = data[i].name;
            node.path = data[i].path;
            node.id = data[i].id;
            node.access = data[i].access;
            node.type = data[i].type;
            node.captchar = data[i].captchar;

            node.value = data[i].name;

            if( data[i]!==undefined && data[i].subcomponents !== undefined && data[i].subcomponents.length > 0 )
            {
                node.children = this.buildTreeData(data[i].subcomponents, node);
            }
            
            items.push(node);
        }

        return items;
    }

    /**
     * 节点选择回调函数
     * @param {*} nodes 
     */
    nodeOnSelect( nodes )
    {
        let tableData = this.buildTableData( nodes );

        this.setState({tableData:tableData});
    }

    /**
     * 创建表格数据
     * @param {*} nodes 
     * @returns 
     */
    buildTableData( nodes )
    {
        // this.props.widgetMessageData(nodes)
        let tableData = [];

        for( let item of nodes )
        {
            let data = {};

            data["name"] = item.value;
            data["title"] = item.label;
            data["type"] = item.type;
            data["access"] = item.access;
            data["path"] = item.path;

            let fullPath = this.buildFullPath(item);

            data["fullPath"] = fullPath;

            tableData.push(data);
            

        }
        // this.props.widgetMessageData(nodes)

        return tableData;
    }

    /**
     * 创建全路径
     * @param {*} node 
     * @returns 
     */
    buildFullPath( node )
    {
        let path = node.label;

        if( node.parent!==undefined && node.parent!==-1)
        {
            path = this.buildFullPath(node.parent) + " / " + path;
        }

        return path;
    }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }

        switch( type )
        {
            case "remove":
            {
                this.removeGroupPrivilege(data);
                break;
            }
            default:
                break;
        }
    }

    /**
     * 删除用户组权限
     * @param {*} data 
     */
    removeGroupPrivilege( data )
    {
        let nodes = [], treeDefaultValue = [];

        let { tableData, treeData } = this.state;

        let node = this.findTreeNode(data, treeData);

        this.findAllNodes(node, nodes);

        for( let item of nodes )
        {
            for( let i=0; i<tableData.length; i++ )
            {
                if( tableData[i].name===item.name )
                {
                    tableData.splice(i, 1);
                    break;
                }
            }
        }

        for(let item of tableData )
        {
            treeDefaultValue.push(item.name );
        }

        this.setState({tableData:tableData, treeDefaultValue:treeDefaultValue});
    }

    findTreeNode( data, treeData)
    {
        let node;
        for( let item of treeData)
        {
            if( item.name===data.name )
            {
                node = item;
            }
            else 
            {
                if( item.children!==undefined )
                {
                    node = this.findTreeNode(data, item.children);
                }
            }
            
            if( node!==undefined && node!==null )
            {
                return node;
            }
        }

        return node;
    }

    /**
     * 找出所有节点
     * @param {*} node 
     * @param {*} nodes 
     */
    findAllNodes( node, nodes )
    {
        nodes.push(node);

        if( node.children!==undefined && node.children!==null )
        {
            for( let item of node.children )
            {
                this.findAllNodes(item, nodes);
            }
        }
    }

    // 跳转回权限
    groupPrivilege()
    {
        this.props.history.push('/home/role');
    }

    /**
     * 保存页面
     */
    savePage()
    {
        const { tableData, path, group, methodPrivileges} = this.state;

        let privilege = {};

        for( let item of tableData )
        {
            let privilegeContent = {
                type : "COMPONENT",
                privilege : item.access,
                limits : -1
            }

            privilege[item.name] = privilegeContent;
        }

        for( let item of methodPrivileges )
        {
            privilege[item.name] = item;
        }

        let params = {
            id : group.id,
            privilege : privilege
        }

        WidgetAjax.ajax({url:path + 'role/set_privilege', params:params, callback:this.onSavePage});
    }

    /**
     * 保存页面回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onSavePage( result, params )
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
            messageOptions["message"] = "角色权限设置成功！" ;
            
        }
        else
        {
            messageOptions["message"] = "角色权限设置失败！" ;
        }

        this.messageRef.open();
        setTimeout(()=>{
            this.props.history.push('/home/role')
        },1500)
    }

    /**
     * 取消页面
     */
    cancelPage()
    {
        // this.loadComponent();
        this.props.history.push('/home/role')
    }

    render()
    {
        const { group, tableData, options, columns, total, treeOptions, treeData, treeDefaultValue, messageOptions, beforeParentPage } = this.state;

        return (
            <div className="page">
                <div className="page-weidu" style={{paddingTop:"0"}}>
                    <div className="page-title">
                        <div className='go_back'style={{marginTop:"11px"}} onClick={()=>{ this.props.history.push('/home/role') }}>
                            <img src={require('./img/icon/back.svg')} className='backBtn'  /></div>
                        {/* <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font"> 用户角色权限配置 </span> / <span className="page-title-path-font">{group.name}</span> */}
                        <p className='go_back_title'>{"角色权限管理 /"}<span style={{color:"#646464"}}>{" " + beforeParentPage.name}</span></p>
                    </div>
                </div>
                
                <div className="page-content page-overflow" >
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-left">
                            <div className="catalog">
                                <img src={require("./img/icon/fileders.svg")} style={{marginTop:"15px"}}></img>
                                <span>全部目录</span>
                            </div>
                            <div className="left-tree" >
                                <WidgetTree options={treeOptions} data={treeData} defaultValue={treeDefaultValue} onSelect={this.nodeOnSelect}></WidgetTree>
                            </div>
                        </div>

                        <div className="content-right group-content-right">

                            <div className="group-content-right-body">
                                <div style={{height:'calc(100% - 50px)'}}>
                                    <WidgetTable 
                                        options={options} 
                                        data={tableData} 
                                        columns={columns} 
                                        // total={total} 
                                        notify={this.onEvent} 
                                        height={"690px"}
                                    ></WidgetTable>
                                </div>
                                
                                <div className="group-content-footer">
                                    <div className="footer-button">
                                        <div className="button footer-cancel">
                                            <span className="addUser" onClick={this.cancelPage}>取消</span>
                                        </div>
                                        <div className="button footer-submit">
                                            <span className="addUser" onClick={this.savePage}>确定</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default RolePrivilege
